import { TRESPONSE_ORDER_CHECKLIST_LISTING } from '@monorepo/types';
import { TAccordion, TAccordionTableVM } from '@monorepo/ui';

export const ORDER_CHECKLIST_ACCORDION_TABLE_MODEL = {
  createModel(orders?: TRESPONSE_ORDER_CHECKLIST_LISTING['orders'], showSelection = false): TAccordionTableVM {
    return {
      headers: [
        { label: 'ORDER ID', colSize: 7 },
        { label: 'BUYER', colSize: 7 },
        { label: 'ERP KEY', colSize: 7 },
        { label: '', colSize: 3 },
      ],
      options: showSelection ? {
        select: {
          isMulti: true,
          selectAllApplicable: true,
        },
      } : undefined,
      accordions: orders
        ? orders.map((order): TAccordion => {
            return {
              id: order.otlId,
              isMinimized: true,
              hideToggleButtons: true,
              tag: order.checklistComplete === true ? [{ displayName: '3-step verified', frequency: 0, class: 'accordian-table__tag--blue' }] : undefined,
              rowItems: [
                { type: 'TEXT', value: order.userOtlId },
                { type: 'TEXT', value: order.buyer },
                { type: 'TEXT', value: order.erp },
                { type: 'ACTION', actionId: 'VIEW_DETAILS', icon: 'assets/icon/common/view-details-icon.svg' },
              ],
              moreInfo: [],
              actions: [],
            };
          })
        : [],
    };
  },
};
